module.exports = __webpack_public_path__ + "media/images/chosen-sprite@2x-a0b7f3f18d93f6730bb20aa64fb27644.png";